export const enum RolePermission {
  CREATE = 'C',
  READ = 'R',
  UPDATE = 'U',
  DELETE = 'D',
}

export const permissions = {
  charity: {
    mikaAdmin: {
      organization: 'CRUD',
      campaign: 'CRUD',
      merchant: 'CRUD',
      user: 'CRUD',
      transactions: '',
      installation: '',
      kiosk: 'CRUD',
      reports: 'CR',
      credentials: '',
      ecommerce: '',
      serviceProvider: '',
    },
    portfolioAdmin: {
      organization: 'CRUD',
      campaign: 'CRUD',
      merchant: 'R',
      user: 'CRUD',
      transactions: 'R',
      installation: '',
      kiosk: 'CRUD',
      reports: 'CRUD',
      credentials: '',
      ecommerce: '',
      serviceProvider: '',
    },
    servicePortfolioAdmin: {
      organization: 'CRUD',
      campaign: '',
      merchant: 'R',
      user: 'CRUD',
      transactions: 'R',
      installation: '',
      kiosk: 'CRUD',
      reports: 'CR',
      credentials: '',
      ecommerce: '',
      serviceProvider: '',
    },
    orgAdmin: {
      organization: 'R',
      campaign: 'CRUD',
      merchant: 'R',
      user: 'CRUD',
      transactions: 'R',
      installation: '',
      kiosk: 'CRUD',
      reports: 'CR',
      credentials: '',
      ecommerce: 'CRUD',
      serviceProvider: '',
    },
    campaignAdmin: {
      organization: 'CRUD',
      campaign: 'CRUD',
      merchant: '',
      user: 'CRUD',
      transactions: 'R',
      installation: '',
      kiosk: 'CRUD',
      reports: 'CR',
      credentials: '',
      ecommerce: '',
      serviceProvider: '',
    },
  },
  retail: {
    mikaAdmin: {
      organization: 'CRU',
      campaign: 'CRU',
      merchant: 'CRUD',
      user: 'CRU',
      transactions: '',
      installation: '',
      kiosk: 'CRU',
      reports: 'CR',
      credentials: '',
      ecommerce: '',
      serviceProvider: 'CRUD',
    },
    portfolioAdmin: {
      organization: 'CRU',
      campaign: '',
      merchant: 'CRUD',
      user: 'CRU',
      transactions: 'R',
      installation: 'CRUD',
      kiosk: '',
      reports: 'CRU',
      credentials: 'CRUD',
      ecommerce: '',
      serviceProvider: 'CRUD',
    },
    servicePortfolioAdmin: {
      organization: 'CRU',
      campaign: '',
      merchant: 'R',
      user: 'CRU',
      transactions: 'R',
      installation: 'CRU',
      kiosk: '',
      reports: 'CR',
      credentials: 'CRUD',
      ecommerce: '',
      serviceProvider: '',
    },
    orgAdmin: {
      organization: 'RU',
      campaign: '',
      merchant: 'R',
      user: 'CRU',
      transactions: 'R',
      installation: 'CRU',
      kiosk: '',
      reports: '',
      credentials: '',
      ecommerce: 'CRUD',
      serviceProvider: '',
    },
    campaignAdmin: {
      organization: 'CRU',
      campaign: 'CRU',
      merchant: '',
      user: 'CRU',
      transactions: 'R',
      installation: '',
      kiosk: 'CRU',
      reports: 'CR',
      credentials: '',
      ecommerce: '',
      serviceProvider: '',
    },
  },
}

export const hiddenFields = {
  mikaAdmin: [],
  portfolioAdmin: ['orgLogo', 'orgSignature', 'orgCharityNumber'],
  servicePortfolioAdmin: ['orgLogo', 'orgSignature'],
  orgAdmin: [],
  campaignAdmin: [],
}
export const restrictions = {
  orgAdmin: {
    custom: 'portfolioId',
    restricted: ['campaign', 'reportsCampaign'],
  },
  portfolioAdmin: {
    custom: 'portfolioId',
    restricted: ['reportsCampaign', 'kiosk'],
  },
  servicePortfolioAdmin: {
    custom: 'portfolioId',
    restricted: ['reportsCampaign'],
  },
}
export const required = { orgAdmin: { installation: ['portfolioId'] } }
